<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container >
      <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail">
        <a-row>
          <a-col :span="24">
            <a-form-model-item :label="language['factory']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="factoryId">
              <a-select v-model="model.factoryId" :options="factoryOptions" :placeholder="language['common.pleaseInput']+language['factory']" :disabled="formDisabled">
               </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :label="language['danger.areaCode']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="areaCode">
              <a-input v-model="model.areaCode" maxLength=100 :placeholder="language['common.pleaseInput']+language['danger.areaCode']"  :disabled="formDisabled"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :label="language['danger.areaName']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="areaName">
              <a-input v-model="model.areaName" maxLength=100 :placeholder="language['common.pleaseInput']+language['danger.areaName']" style="width: 85%" :disabled="formDisabled"></a-input>
              <a-button @click="languageModelOpen('EpBdFactoryArea','areaName',areaNameLanguages)" type="primary"  style="left: 3%" >{{language['common.language']}}</a-button>
            </a-form-model-item>
          </a-col>          
          <!-- <a-col :span="24">
            <a-form-model-item label="创建者" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="createBy">
              <a-input v-model="model.createBy" :placeholder="nickname()" disabled placeholder="请输入创建者"  ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="创建时间" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="createTime">
              <j-date placeholder="请选择创建时间" :placeholder="getdate()"  disabled v-model="model.createTime"  style="width: 100%" />
            </a-form-model-item>
          </a-col> -->
        </a-row>
      </a-form-model>
    </j-form-container>
    <language-model ref="languageModel" @ok="languageOk"></language-model>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import { validateDuplicateValue } from '@/utils/util'
  import { mapActions, mapGetters,mapState } from 'vuex'
  import LanguageModel from "@/components/LanguageModel"

  export default {
    name: 'EpBdFactoryAreaForm',
    components: {
      LanguageModel
    },
    props: {
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        model:{
         },
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        factoryOptions:[],
        confirmLoading: false,
        url: {
          add: "/sys/epBdFactoryArea/add",
          edit: "/sys/epBdFactoryArea/edit",
          queryById: "/sys/epBdFactoryArea/queryById",
          queryFactoryList: '/sys/epFactory/list',
        },
        areaNameLanguages:[],
      }
    },
    computed: {
      language() {
        return this.$store.getters.language
      },
      validatorRules(){
        if(this.language){
          return {
           areaCode: [
              { required: true, message: this.language['common.pleaseInput']+this.language['danger.areaCode']},
           ],
           areaName: [
              { required: true, message: this.language['common.pleaseInput']+this.language['danger.areaName']},
           ],
           factoryId: [
              { required: true, message: this.language['common.pleaseInput']+this.language['factory']},
           ],
        }
        }
      },
      formDisabled(){
        return this.disabled
      },
    },
    created () {
      this.initfactoryList();
       //备份model原始值
      this.modelDefault = JSON.parse(JSON.stringify(this.model));
    },
    methods: {
      languageModelOpen(dataTable,dataColumn,languagelist){
        this.$refs.languageModel.edit("platform",dataTable,dataColumn,this.model.id,languagelist,this.disabled);
      },
      languageOk(map){
        if(map&&map.dataColumn == 'areaName'){
          this.areaNameLanguages = map.languagelist;
        }
      },
      initLanguagetemp(dataTable,dataColumn,dataId) {
        getAction("/sys/syslanguagedata/querylistby", {
          applicationCode: "platform",
          dataTable: dataTable,
          dataColumn: dataColumn,
          dataId: dataId
        }).then((res) => {
          if (res.success) {
            this.areaNameLanguages = res.result;
          }
        })
      },
      ...mapGetters(["nickname","userInfo"]),
      getdate()
      {
          let month =parseInt(new Date().getMonth())+1;
          return new Date().getFullYear()+"/"+month+"/"+new Date().getDate();
      },
      //初始化厂区字典
      initfactoryList(){
		  let para={pageNo:1,pageSize:1000};
        getAction(this.url.queryFactoryList,para).then(res=>{
          if(res.success){
            this.factoryOptions = res.result.records.map((item,index,arr)=>{
              let c = {label:item.factoryName, value: item.id+""}
              return c;
            })
          }
        })
      },
      add () {
        this.edit(this.modelDefault);
      },
      edit (record) {
        this.model = Object.assign({}, record);
        this.visible = true;
        this.initLanguagetemp('EpBdFactoryArea','areaName',record.id)
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            httpAction(httpurl,this.model,method).then((res)=>{
              if(res.success){
                this.areaNameLanguages.forEach(item=>{
                  if(!item.dataId){
                    item.dataId = res.result.id;
                  }
                })
                httpAction("/sys/syslanguagedata/saveSysLanguageDataList",this.areaNameLanguages,"post").then((res)=>{
                  if(res.success){
                    that.$message.success(res.message);
                    that.$emit('ok');
                    that.confirmLoading = false;
                  }
                })
              }else{
                that.$message.warning(res.message);
                that.confirmLoading = false;
              }
            })
          }
         
        })
      },
    }
  }
</script>